import { Tabs } from 'antd';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)`
    color: var(--gray-10);
    overflow: visible;

    .ant-tabs-tab {
        cursor: pointer;
    }

    .ant-tabs-tab:hover {
        color: var(--brand-5);
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: var(--brand-6);
    }

    .ant-tabs-ink-bar {
        background-color: var(--brand-6);
    }

    .ant-tabs-nav .ant-tabs-ink-bar {
        height: 2px;
    }
`;
